import { AspectRatio, type AspectRatioProps, Image } from '@mantine/core';
import type { PropsWithChildren } from 'react';
export type ImageRatioType = PropsWithChildren<AspectRatioProps> & {
  src: string;
  alt: string;
};
export const ImageRatio: React.FC<ImageRatioType> = ({
  children,
  src,
  alt,
  ...props
}) => {
  return <AspectRatio mx="auto" pos="relative" mb={{
    base: 20,
    sm: 0
  }} {...props}>
      <Image src={src} alt={alt} />
      {children}
    </AspectRatio>;
};